import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authSession, setSessionToken } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    if (sessionId) {
      authSession(sessionId)
        .then(async (res) => {
          if (res.data?.session_token) {
            setSessionToken(res.data.session_token);
          }
          // Tous les utilisateurs (admin, abonnés ou non) atterrissent
          // désormais sur le Dashboard personnel.
          // Les restrictions PRO sont appliquées au cas par cas (carnet, etc).
          const userData = res.data || {};
          navigate('/dashboard', { state: { user: userData }, replace: true });
        })
        .catch(() => {
          navigate('/', { replace: true });
        });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#0A0A0A' }} data-testid="auth-callback">
      <div className="text-center space-y-4">
        <Loader2 className="w-10 h-10 animate-spin mx-auto" style={{ color: '#2D6A4F' }} />
        <p className="text-sm" style={{ color: '#7A7A7A', fontFamily: 'IBM Plex Sans, sans-serif' }}>
          Connexion en cours...
        </p>
      </div>
    </div>
  );
}
